import React from 'react';
import DataCortex from './data_cortex';

export default {
  useAnalytics,
  log: DataCortex.log,
  preInit,
  init,
  addUserTag: DataCortex.addUserTag,
  loadFinish,
  showScreen,
  hideScreen,
  appleLoginSuccess,
  facebookLoginSuccess,
  gameLoginSuccess,
  promoClick,
  acceptTerms,
  showProduct,
};
export function useAnalytics(func: any, ...args: any[]) {
  React.useEffect(() => {
    func(...args);
  }, [func, args]);
}

const API_KEY =
  process.env.NODE_ENV === 'development'
    ? process.env.DC_API_KEY_DEV
    : process.env.DC_API_KEY;

let g_preInitDone = false;
export function preInit(done?: any) {
  if (!g_preInitDone) {
    g_preInitDone = true;
    const opts = {
      api_key: API_KEY,
      org_name: process.env.DC_ORG_NAME,
      app_ver: process.env.VERSION,
      add_error_handler: true,
    };
    DataCortex.init(opts);
  }
  done?.();
}
export function init(done?: any) {
  done?.();
}
export function loadFinish() {
  const event = { kingdom: 'game', phylum: 'load_finish' };
  DataCortex.event(event);
}
export function facebookLoginSuccess() {
  const event = { kingdom: 'game', phylum: 'facebook_login_success' };
  DataCortex.event(event);
}
export function appleLoginSuccess() {
  const event = { kingdom: 'game', phylum: 'apple_login_success' };
  DataCortex.event(event);
}
export function gameLoginSuccess() {
  const event = { kingdom: 'game', phylum: 'game_login_success' };
  DataCortex.event(event);
}
export function showScreen(screen_name: string) {
  const event = { kingdom: 'game', phylum: 'show_screen', class: screen_name };
  DataCortex.event(event);
}
export function hideScreen(screen_name: string) {
  const event = { kingdom: 'game', phylum: 'hide_screen', class: screen_name };
  DataCortex.event(event);
}
export function promoClick(promo_name: string) {
  const event = { kingdom: 'promo', phylum: 'click', class: promo_name };
  DataCortex.event(event);
}
export function acceptTerms() {
  const event = { kingdom: 'game', phylum: 'accept_terms' };
  DataCortex.event(event);
}
export function showProduct(product_id: any) {
  const event = {
    kingdom: 'game',
    phylum: 'show_screen',
    class: 'product',
    species: String(product_id),
  };
  DataCortex.event(event);
}
